// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/account-details-page/account-details-page.css
// module id = 822
// module chunks = 0